import { IdLabelDto } from 'api/responses/models/Common/IdLabelDto';
import { EmptyTextData } from 'library/types';

export const customModelKey = 'otherModel';

export const customBrandKey = 'otherBrand';

export const isCustomBrand = (brandValue: EmptyTextData) =>
	brandValue === customBrandKey;

export const isCustomModel = (modelValue: EmptyTextData) =>
	modelValue === customModelKey;

export const getBrand = (
	brand: IdLabelDto | null | undefined,
	customBrand: EmptyTextData
) => (isCustomBrand(brand?.id) ? customBrand : brand?.label) ?? null;

export const getModel = (
	brand: IdLabelDto | null | undefined,
	customBrand: EmptyTextData
) => (isCustomModel(brand?.id) ? customBrand : brand?.label) ?? null;
